import { createElement } from 'react';

const UserMenuGroupAction = _ref => {
  let {
    href,
    onClick,
    children
  } = _ref;
  return /*#__PURE__*/createElement(href ? 'a' : 'button', {
    href,
    onClick,
    className: 'nav-link'
  }, children);
};

export default UserMenuGroupAction;